module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av740-7d61c069cf18200ae4c4e5c904c3564c.jpg";